import React from 'react'
import { PaddingType } from './types/stylesTypes'

type ColumnPropsType = {
  children: React.ReactNode
  size: 3 | 4 | 6 | 8 | 12 | number
  backgroundImageUrl?: string
  padding: PaddingType
}

function Column({ size, children, padding }: ColumnPropsType) {
  const width = size === 12 ? 100 : Math.round((100 * size) / 12)
  return (
    <table
      role="presentation"
      border={0}
      cellPadding="0"
      cellSpacing="0"
      width={`${width}%`}
      className="col"
      align="left"
      style={{ borderSpacing: 0, width: `${width}%` }}
    >
      <tbody>
        <tr>
          <td
            style={{
              paddingTop: padding.paddingTop,
              paddingRight: padding.paddingRight,
              paddingBottom: padding.paddingBottom,
              paddingLeft: padding.paddingLeft,
              height: 1,
            }}
          >
            {children}
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Column
